import { Controller } from 'stimulus'

const STRING  = "string"
const BOOLEAN = "boolean"
const DATE    = "date"
const INTEGER = "integer"
const FLOAT   = "float"
const OPTIONS = "options"
const PHOTO   = "photo"
const TITLE   = "sub_title"

export default class extends Controller {
  static targets = ['required', 'options', 'filterable', 'special', 'selectType', 'showOnPdf']

  connect() {
    this._setAvailableFunctions()
    this._toggleFilterable()
  }

  changeSelection() {
    const value = this.selectTypeTarget.value

    if (value == this.data.get(BOOLEAN) || value == TITLE) {
      this._hideIt(this.requiredTarget)
    } else {
      this._showIt(this.requiredTarget)
    }

    if (this.hasShowOnPdfTarget) {
      if (value == this.data.get(PHOTO)) {
        this._hideIt(this.showOnPdfTarget)
      } else {
        this._showIt(this.showOnPdfTarget)
      }
    }

    if (value == this.data.get(OPTIONS)) {
      this._showIt(this.optionsTarget)
    } else {
      this._hideIt(this.optionsTarget)
    }
    this._toggleFilterable()
    this._resetSpecial()
    this._setAvailableFunctions()
  }

  // private

  _hideIt(element){
    element.classList.add('d-none')
  }

  _showIt(element){
    element.classList.remove('d-none')
  }

  _resetSpecial(element){
    if(!this.hasSpecialTarget) return

    this.specialTarget.options.selectedIndex = 0
  }

  _toggleFilterable() {
    if (!this.hasFilterableTarget) return

    const value = this.selectTypeTarget.value
    const isFilterable = [OPTIONS, DATE].includes(value)

    if (isFilterable) {
      this._showIt(this.filterableTarget)
    } else {
      this._hideIt(this.filterableTarget)
      this.filterableTarget.querySelector('input[type="checkbox"]').checked = false
    }
  }

  _setAvailableFunctions() {
    if(!this.hasSpecialTarget) return

    const selected = this.selectTypeTarget.value
    this.specialTarget.options.forEach(option => {
      const notPrompt = !!option.value
      const available = option.dataset.available == selected
      option.disabled = notPrompt && !available
    })
  }
}
